export default __webpack_public_path__ + "static/media/remove.236d32b2.svg";